import { Component, OnInit } from '@angular/core';
import {DialogDefinitionEditorBase} from "@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models";

@Component({
    standalone: false,
    selector: 'app-dialog-definition-navigation',
  templateUrl: './dialog-definition-navigation.component.html',
  styleUrls: ['./dialog-definition-navigation.component.scss']
})
export class DialogDefinitionNavigationComponent extends DialogDefinitionEditorBase implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
